import { observer } from "mobx-react";
import {FormFieldLine} from "../../../../../components/form-field-line/form-field-line";
import {SelectDropdown} from "../../../../../components/inputs/select-dropdown/select-dropdown";
import {IValidationGroup} from "../../../../../hooks/validation-group/validation-group-hook";
import {AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER} from "../../../../../models/User";
import CreateRmaDefaultSettingsEditorStore from "../../../../../stores/create-rma-default-settings-editor-store";
import {
    AUTO_PROCESS_EXECUTE,
    autoProcessExecuteOptionsList,
    autoProcessTriggerOptionsList,
    autoProcessValidatedQualifierOptionsList,
    getAutoProcessSinceValueOptions, SINCE_UNIT,
    sinceUnitOptionsList
} from "../../../../policies/constants";

interface IProps {
    store: CreateRmaDefaultSettingsEditorStore,
    validationGroup: IValidationGroup,
}

const AutoRefundSettings: React.FC<IProps> = observer(({store, validationGroup }) => {
    const selectedAutoProcessTrigger = autoProcessTriggerOptionsList().find(o => o.value === store.autoRefundTrigger);
    const selectedAutoProcessValidatedQualifier = autoProcessValidatedQualifierOptionsList().find(o => o.value === store.autoRefundValidatedQualifier);
    const selectedAutoProcessExecute = autoProcessExecuteOptionsList().find(o => o.value === store.autoRefundExecute);
    const selectedAutoProcessSinceUnit = sinceUnitOptionsList().find(o => o.value === store.autoRefundSinceUnit);
    
    const autoProcessSinceValueOptions = getAutoProcessSinceValueOptions(store.autoRefundSinceUnit);
    const selectedAutoProcessSinceValue = autoProcessSinceValueOptions.find(o => o.value === store.autoRefundSinceValue);
    const showExecuteSince = store.autoRefundExecute && store.autoRefundExecute !== AUTO_PROCESS_EXECUTE.IMMEDIATELY;
    
    return (
        <>
            <FormFieldLine required label='Trigger' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    value={selectedAutoProcessTrigger}
                    options={autoProcessTriggerOptionsList()}
                    onChange={(v) => store.setAutoRefundTrigger(v?.value as AUTO_PROCESS_TRIGGER)}
                    required
                    validationGroup={validationGroup}
                    isSearchable={false}
                />
            </FormFieldLine>
            
            {store.autoRefundTrigger === AUTO_PROCESS_TRIGGER.ITEMS_VALIDATED &&
                <FormFieldLine required label='Validated is' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <SelectDropdown
                        value={selectedAutoProcessValidatedQualifier}
                        options={autoProcessValidatedQualifierOptionsList()}
                        onChange={(v) => store.setAutoRefundValidatedQualifier(v?.value as AUTO_PROCESS_VALIDATED_QUALIFIER)}
                        required
                        validationGroup={validationGroup}
                        isSearchable={false}
                    />
                </FormFieldLine>
            }
            
            <FormFieldLine required label='Execute' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                <SelectDropdown
                    value={selectedAutoProcessExecute}
                    options={autoProcessExecuteOptionsList()}
                    onChange={(v) => store.setAutoRefundExecute(v?.value as AUTO_PROCESS_EXECUTE)}
                    required
                    validationGroup={validationGroup}
                    isSearchable={false}
                />
            </FormFieldLine>
            
            {showExecuteSince &&
                <FormFieldLine label='' gridStyle={{lableWidth: {width: 100, type: 'px'}, childrenWidth: {width: 1, type: 'fr'}}}>
                    <div className="execute-since-fields">
                        <SelectDropdown
                            value={selectedAutoProcessSinceValue}
                            options={autoProcessSinceValueOptions}
                            onChange={(v) => store.setAutoRefundSinceValue(v?.value as number)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />
                        
                        <SelectDropdown
                            value={selectedAutoProcessSinceUnit}
                            options={sinceUnitOptionsList()}
                            onChange={(v) => store.setAutoRefundSinceUnit(v?.value as SINCE_UNIT)}
                            validationGroup={validationGroup}
                            required
                            isSearchable={false}
                        />
                    </div>
                </FormFieldLine>
            }
        </>
    )
});

export default AutoRefundSettings;